<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Ancizar+Sans:ital,wght@0,100..1000;1,100..1000&display=swap"
  rel="stylesheet">

<!-- Spinner global: permanece visível independentemente da rota -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
  <p style="color: white"> Processando, por favor aguarde... </p>
</ngx-spinner>

<!-- Manter o router-outlet sempre presente; aplicar a classe .main-container condicionalmente -->
<div [class.main-container]="shouldShowMainContainer()">
  <router-outlet></router-outlet>
</div>